import React from 'react';
import classNames from 'classnames';
import Link from 'next/link';
import { BlogPostListItem, formattedBlogPublishedDate, getIMGIXOptimisedImage } from './blogPosts';
import style from './BlogPostListItemView.module.scss';
import { GraphCMSRichContent } from '../../components/GraphCMSRichContent';

export const BlogPostListItemView: React.FC<{ post: BlogPostListItem; right?: boolean }> = ({ post }) => {
  const promoImageURL = getIMGIXOptimisedImage(post.attributes.promoImage?.data, 'small');
  return (
    <Link prefetch={false} href="/blog/[slug]" as={`/blog/${post.attributes.slug}`} passHref>
      <div className={style.entryListItem}>
        {promoImageURL && <img className={style.entryListPromo} src={promoImageURL} alt="" />}
        <div className={classNames('pt-3 pb-2', style.entryListContent)}>
          <div className={style.entryListDate}>{formattedBlogPublishedDate(post)}</div>
          <h2 className={style.entryListTitle}>{post.attributes.title}</h2>
          <div className={style.entryListTags}>
            {post.attributes.blogPostTags.data.map((tag) => (
              <span key={tag.id}>{`#${tag.attributes.name} `}</span>
            ))}
          </div>
          <GraphCMSRichContent content={post.attributes.intro} className={style.entryListIntro} />
        </div>
      </div>
    </Link>
  );
};
